// A page's code is downloaded the first time the page is opened (React.lazy).
// When that download fails, every browser says so differently, and until the
// document is reloaded the browser remembers the failure: on 7 Oct 2026 one
// failed download left the whole office portal on the crash screen.

const CHUNK_ERROR = /Importing a module script failed|Failed to fetch dynamically imported module|error loading dynamically imported module|Unable to preload CSS|ChunkLoadError|Loading chunk \S+ failed/i;

/** Is this the "a page's code did not download" error (Safari, Chrome, Firefox, Vite)? */
export function isChunkLoadError(err) {
    return CHUNK_ERROR.test(String(err?.message || err || ''));
}

const RELOAD_KEY = 'parcelink_chunk_reload_at';
export const CHUNK_RELOAD_GAP_MS = 2 * 60 * 1000;

/**
 * Reload once: a fresh document downloads every file again. At most once per
 * two minutes per tab, so a download that keeps failing shows the reload
 * screen instead of reloading for ever. Without session storage there is no
 * guard, so it does not reload at all. Returns whether it reloaded.
 */
export function reloadOnceForChunkError({ now = Date.now(), storage, reload } = {}) {
    const store = storage ?? (typeof window !== 'undefined' ? window.sessionStorage : null);
    const doReload = reload ?? (() => window.location.reload());
    try {
        const last = Number(store.getItem(RELOAD_KEY) || 0);
        if (now - last < CHUNK_RELOAD_GAP_MS) return false;
        store.setItem(RELOAD_KEY, String(now));
    } catch {
        return false;
    }
    doReload();
    return true;
}
